"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var prop_types_1 = require("prop-types");

var rc_steps_1 = __importStar(require("rc-steps"));

require("./index.css");

var ProgressSteps = function (_a) {
  var dataTestId = _a.dataTestId,
      steps = _a.steps,
      current = _a.current,
      width = _a.width;
  return (0, jsx_runtime_1.jsx)("div", __assign({
    className: "stepindicator-container width-" + width,
    "data-testid": dataTestId,
    "data-current": current
  }, {
    children: (0, jsx_runtime_1.jsx)(rc_steps_1.default, __assign({
      current: current - 1,
      className: "progress-indicator"
    }, {
      children: steps.map(function (item) {
        return (0, jsx_runtime_1.jsx)(rc_steps_1.Step, {
          title: item.title,
          description: item.description
        }, item.title);
      })
    }), void 0)
  }), void 0);
};

ProgressSteps.propTypes = {
  dataTestId: prop_types_1.string,
  steps: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    title: prop_types_1.string,
    description: prop_types_1.string
  })).isRequired,
  current: prop_types_1.number.isRequired,
  width: prop_types_1.number
};
ProgressSteps.defaultProps = {
  dataTestId: 'progress-steps',
  width: 40
};
exports.default = ProgressSteps;